<div
  class="prompt-box relative p-2 flex min-h-13 justify-between bg-mib-branding-800 not-height-medium:p-1 not-expanded:min-h-12"
  [class]="biggerPrompt() ? 'rounded-mib items-end' : 'rounded-full items-center small'"
  [style.height]="promptBoxHeight() + 'px'">
  @if (displayPlusButton()) {
    <button
      mibButton
      type="button"
      #plusButton
      theme="ai"
      [size]="buttonSize()"
      class="rounded-full"
      aria-label="Add"
      (click)="clickOnPlusButton()">
      <svg mib-icon name="plus"></svg>
    </button>
  } @else {
    <div></div>
  }

  <div class="absolute flex transition-all ease-in-out duration-200" [class]="textareaPosition()">
    <textarea
      #textarea
      class="w-full border-none outline-none resize-none mib-scrollbar text-sm"
      [class.pr-4]="biggerPrompt()"
      rows="1"
      name="prompt"
      id="prompt"
      [placeholder]="placeholder()"
      [formControl]="userPrompt"
      (input)="updatePromptHeight($event)"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="sendPrompt()"></textarea>
  </div>
  <button
    mibButton
    type="button"
    theme="ai"
    [size]="buttonSize()"
    class="rounded-full"
    aria-label="Send"
    mibTooltip="Send"
    mibTooltipShowDelay="500"
    [disabled]="service.chatLocked()"
    (click)="sendPrompt()">
    <svg mib-icon name="send-horizontal"></svg>
  </button>
</div>
